/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Test_OkInputs */



/**
* | output |
* | --- |
* | "Calendar reachable." |
*
* @param {Connections_Test_OkInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_test_ok = /** @type {((inputs?: Connections_Test_OkInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Test_OkInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Agenda bereikbaar.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Agenda accessible.")
	return /** @type {LocalizedString} */ ("Calendar reachable.")
});